<template>
    <div :class="[ 'qw-input', { 'focused': isFocused } ]">
        <label class="qw-input-label" :for="inputName" v-if="hasLabel">{{ label }}</label>
        <div class="qw-input-field">
            <span class="icon" v-if="hasIcon"><i :class="icon"></i></span>
            <input class="input"
                :name="inputName" 
                :value="value" 
                :id="inputName"
                v-bind="$attrs"
                v-on="listeners" />
            <span class="icon" v-if="hasEndIcon" @click="endButtonClick"><i :class="endIcon"></i></span>
        </div>
    </div>
</template>

<script>
export default {
    name: "qw-input",
    inheritAttrs: false,
    props: {
        name: {
            required: true,
            type: String
        },
        icon: {
            required: false,
            type: String,
            default: ""
        },
        endIcon: {
            required: false,
            type: String,
            default: ""
        },
        label: {
            required: false,
            type: String,
            default: "",
        },
        value: {}
    },
    data() {
        return {
            isFocused: false
        }
    },
    methods: {
        endButtonClick() {
            this.$emit('buttonClick');
        }
    },
    computed: {
        hasIcon() {
            return this.icon && this.icon.length > 0 ? true : false;
        },
        hasEndIcon() {
            return this.endIcon && this.endIcon.length > 0 ? true : false;
        },
        hasLabel() {
            return this.label && this.label.length > 0 ? true : false;
        },
        inputName() {
            return `${this.name}-form-input`;
        },
        listeners() {
            return {
                ...this.$listeners,
                input: e => this.$emit('input', e.target.value), 
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                focus: () => this.isFocused = true,
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                blur: () => this.isFocused = false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.qw-input {
    .qw-input-label {
        font-size: 13px;
        font-family: $lato;
        font-weight: normal;
        color: $dark-gray;
        margin: 0 0 2px 0;
    }
    .qw-input-field {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
        padding: 10px 15px;
        background-color: $light-gray;
        border-radius: 3px;
        @include fastestTransition;
        .icon {
            margin: 0px 15px 0px 0px;
            color: $darker-gray;
        }
        .input {
            width: 100%;
            background: none;
            border: none;
            color: $text-color;
            @include removeBootstrapOutline;
            font-family: $lato;
            &::placeholder {
                color: $darker-gray;
            }
        }
    }
    &.focused {
        .qw-input-field {
            background-color: $gray;
        }
    }
    @media screen and (max-width: $breakpoint-sm) {
        .qw-input-field {
            padding: 8px 15px;
        }
    }
}

.dark {
    .qw-input {
        .qw-input-label {
            color: $gray;
        }
        .qw-input-field {
            background-color: $extra-dark-gray;
            .icon {
                color: $dark-gray;
            }
            .input {
                color: $light-gray;
                &::placeholder {
                    color: $dark-gray;
                }
            }
        }
        &.focused {
            .qw-input-field {
                background-color: darken($extra-dark-gray, 5%);
            }
        }
    }
}
</style>
